import { generatePath as generatePathBase } from 'react-router-dom';
import type { routes } from './routes';

export function generatePath<Path extends (typeof routes)[number]>(path: Path, params: PathParams<Path>): string {
  return generatePathBase(path, params as Record<string, unknown>);
}

/**
 * Regex patterns for Hydra-only URLs that don't require loading an app bundle
 */
const HYDRA_ONLY_URLS_REGEX = [
  /^\/workspaces\/(last|(\d+))\/settings\/ai-business-profile/i,
  /^\/workspaces\/(last|(\d+))\/settings\/audit-logs/i,
  /^\/settings\/audit-logs/i,
  /^\/workspaces\/(last|(\d+))\/assistant/i,
  /^\/workspaces\/(last|(\d+))\/tasks/i,
];

/**
 * Checks if a URL path matches a Hydra-only route.
 *
 * @example
 * isHydraRoute('/workspaces/123/assistant') // true
 * isHydraRoute('/workspaces/last/settings/ai-business-profile') // true
 * isHydraRoute('/workspaces/123/foo') // false
 */
export function isHydraRoute(path: string): boolean {
  return HYDRA_ONLY_URLS_REGEX.some((regex) => regex.test(path));
}

/**
 * Magic types to extract path parameters from a route
 */
type ExtractPathParams<T extends string> = T extends `${infer _}:${infer Parameter}/${infer Rest}`
  ? Parameter | ExtractPathParams<Rest>
  : T extends `${infer _}:${infer Parameter}`
  ? Parameter
  : never;

type PathParams<T extends string> = {
  [K in ExtractPathParams<T>]: string | number;
};
